export interface JWTPayload {
  sub: string;
  username: string;
  name?: string;
  role: string;
  permissions: string[];
  workspaceIds?: string[];
  exp: number;
  iat: number;
}

export const decodeJWT = (token: string): JWTPayload => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload) as JWTPayload;
  } catch {
    throw new Error('Invalid token');
  }
};
